import * as React from "react";

export const Checkbox = React.forwardRef(({ checked, onCheckedChange, className = "" }, ref) => {
  return (
    <input
      type="checkbox"
      ref={ref}
      checked={checked}
      onChange={(e) => onCheckedChange(e.target.checked)}
      className={`h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500 ${className}`}
    />
  );
});

Checkbox.displayName = "Checkbox";
